import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-productpricetypedelete',
  templateUrl: './productpricetypedelete.component.html',
  styleUrls: ['./productpricetypedelete.component.scss']
})
export class ProductpricetypedeleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
